import {
  type PropsWithChildren,
  createContext,
  useContext,
  useState
} from 'react';

import PageLoadSpinner from 'reservations/base/components/PageLoadSpinner';

interface LoadingSpinnerContextInterface {
  isLoading: boolean;
  handleIsLoading: (_: string) => void;
  handleHasLoaded: () => void;
}

export const LoadingSpinnerContext =
  createContext<LoadingSpinnerContextInterface | null>(null);

const LoadingSpinnerProvider = ({ children }: PropsWithChildren) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleIsLoading = (msg: string) => {
    setIsLoading(true);
    setMessage(msg);
  };

  // istanbul ignore next
  const handleHasLoaded = () => {
    setIsLoading(false);
    setMessage('');
  };

  return (
    <LoadingSpinnerContext.Provider
      value={{ isLoading, handleIsLoading, handleHasLoaded }}
    >
      {isLoading && <PageLoadSpinner message={message} isLoading={isLoading} />}
      {children}
    </LoadingSpinnerContext.Provider>
  );
};

export const useLoadingSpinner = () => {
  const context = useContext(LoadingSpinnerContext);
  if (context == null) {
    throw new Error(
      'useLoadingSpinner must be used within LoadingSpinnerProvider'
    );
  }

  return context;
};

export default LoadingSpinnerProvider;
